import type { ReactNode } from 'react';
import { MultiSportMarkStack, SportMarkTile } from '../../components/ui/SportMarks';
import { ChevronRight } from '../../components/ui/icons';
import { FOOTBALL_LEAGUE_COUNT } from '../../data/leagues';
import { LiveTag, SoonTag } from './shared';

// ── Step 1 · Two sports overview ──────────────────────────────────────────────
export function OverviewCard() {
  return (
    <div className="flex flex-col gap-[10px]">
      <SportTile
        sport="football"
        title="Football"
        sub={`${FOOTBALL_LEAGUE_COUNT} leagues · live now`}
        trailing={<LiveTag />}
      />
      <SportTile
        sport="cycling"
        title="Cycling"
        sub="Grand Tours, Monuments & Classics"
        trailing={<LiveTag />}
      />
      <div className="flex items-center gap-[13px] rounded-[18px] border border-dashed border-black/[0.14] bg-wash p-[12px_14px]">
        <MultiSportMarkStack />
        <div className="min-w-0 flex-1">
          <div className="text-[14px] font-bold tracking-tight text-ink">Basketball, Tennis &amp; more</div>
          <div className="mt-px text-[12px] font-medium text-ink2">Landing this season</div>
        </div>
        <SoonTag />
      </div>
    </div>
  );
}

function SportTile({
  sport,
  title,
  sub,
  trailing
}: {
  sport: 'football' | 'cycling';
  title: string;
  sub: string;
  trailing: ReactNode;
}) {
  return (
    <div className="flex items-center gap-[13px] rounded-[18px] border border-black/[0.07] bg-white p-[12px_14px] shadow-[0_10px_26px_-22px_rgba(20,20,50,0.4)]">
      <SportMarkTile sport={sport} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-[7px]">
          <span className="text-[15px] font-extrabold tracking-tight text-ink">{title}</span>
          {trailing}
        </div>
        <div className="mt-0.5 truncate text-[12px] font-medium text-ink2">{sub}</div>
      </div>
      <ChevronRight width={16} height={16} strokeWidth={2.4} className="shrink-0 text-ink4" />
    </div>
  );
}
